import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { ConsentRequest, ConsentValidateRequest } from 'Models/RequestModels/Health'
import {
  ConsentResponse,
  ValidateOTPConsentResponse,
} from 'Models/ResponseModels/Health/ckycSlice.ds'
import { addOnType, countryType, SumInsuredType, TravelCustomerType } from 'Models/Travel'
import {
  CKYCData,
  ConsentResponseData,
  ProposalData,
  IQuoteDetailsTravel,
  PaymentResponse,
} from 'Pages/Sachet/Travel/types'
import { bobTravelUrlQuery } from 'Services/baseQuery'
import { makeQuery } from 'Services/general'

export const travelApi = createApi({
  reducerPath: 'travelApi',
  baseQuery: bobTravelUrlQuery,
  endpoints: (builder) => ({
    createTravelCustomer: builder.mutation<TravelCustomerType, TravelCustomerType>({
      query: (body) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.CREATE_TRAVEL_CUSTOMER}`,
        method: 'POST',
        body: body,
      }),
    }),
    getTravelCountries: builder.query<countryType[], any>({
      query: () => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_COUNTRIES_LIST}`,
        method: 'GET',
      }),
    }),
    getAddons: builder.query<addOnType[], any>({
      query: () => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_ADDONS}`,
        method: 'GET',
      }),
    }),
    createQuote: builder.mutation({
      query: (body) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.CREATE_QUOTE}`,
        method: 'POST',
        body: body,
      }),
    }),
    getQoutesList: builder.query({
      query: (params) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.CREATE_QUOTE}`,
        method: 'GET',
        params: params,
      }),
    }),
    getSumAssured: builder.query<SumInsuredType[], any>({
      query: () => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_SUM_INSURRED}`,
        method: 'GET',
      }),
    }),
    getCkycOptions: builder.query({
      query: (params: { insurance_code: string }) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_CKYC_OPTIONS}`,
        method: 'GET',
        params: params,
      }),
    }),
    uploadCkycValidationTravel: builder.mutation<CKYCData, any>({
      query: (payload: any) => ({
        url: API_ENDPOINTS.BOB.TRAVEL.POST_CKYC_NUMBER,
        method: 'POST',
        body: payload,
      }),
    }),
    createConsentLink: builder.mutation({
      query: (body) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_TRAVEL_CUSTOMER_CONSENT}/create/`,
        method: 'POST',
        body: body,
      }),
    }),
    getConsentStatus: builder.query<ConsentResponseData, any>({
      query: ({ consent_id }) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_TRAVEL_CUSTOMER_CONSENT}/${consent_id}/get-data`,
        method: 'GET',
      }),
    }),
    getPaymentStatus: builder.query<any, any>({
      query: (params) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_TRAVEL_PAYMENT_STATUS}`,
        method: 'GET',
        params: params,
      }),
    }),
    updateSPConsentStatus: builder.mutation({
      query: ({ consent_id, payload }) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_TRAVEL_CUSTOMER_CONSENT}/${consent_id}/update-status/`,
        method: 'POST',
        body: payload,
      }),
    }),

    sendOTPForConsentTravel: builder.mutation<ConsentResponse, ConsentRequest>({
      query: (payload: ConsentRequest) => ({
        url: API_ENDPOINTS.OTP_CONSENT + '/',
        method: 'POST',
        body: makeQuery(payload),
      }),
    }),
    validateOTPForConsentTravel: builder.mutation<
      ValidateOTPConsentResponse,
      ConsentValidateRequest
    >({
      query: (payload: ConsentValidateRequest) => ({
        url: API_ENDPOINTS.OTP_VALIDATE_CONSENT + '/',
        method: 'POST',
        body: makeQuery(payload),
      }),
    }),

    PostPaymentConsent: builder.mutation<PaymentResponse, IQuoteDetailsTravel>({
      query: (payload: IQuoteDetailsTravel) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.POST_PAYMENT_CONSENT}`,
        method: 'POST',
        body: payload,
      }),
    }),
    createTravelProposal: builder.mutation<any, ProposalData>({
      query: (body) => ({
        url: `${API_ENDPOINTS.BOB.TRAVEL.CREATE_PROPOSAL}`,
        method: 'POST',
        body: body,
      }),
    }),
    getPolicyDetails: builder.query<any, {
      insurance_code: string
    }>({
      query: (params) => {
        return {
        url: `${API_ENDPOINTS.BOB.TRAVEL.GET_POLICY_DETAILS}`,
        method: 'GET',
        params: params,
      }},
    })
  }),
})

export const {
  useLazyGetTravelCountriesQuery,
  useLazyGetAddonsQuery,
  useGetCkycOptionsQuery,
  useUploadCkycValidationTravelMutation,
  useLazyGetQoutesListQuery,
  useCreateQuoteMutation,
  useLazyGetSumAssuredQuery,
  useCreateTravelCustomerMutation,
  useCreateConsentLinkMutation,
  useLazyGetConsentStatusQuery,
  useLazyGetPaymentStatusQuery,
  useUpdateSPConsentStatusMutation,
  usePostPaymentConsentMutation,
  useSendOTPForConsentTravelMutation,
  useValidateOTPForConsentTravelMutation,
  useCreateTravelProposalMutation,
  useLazyGetPolicyDetailsQuery
} = travelApi
